export default __webpack_public_path__ + "static/media/logo.48f496de.png";